<template>
  <div>
    <Content nav="true" admin="true">
      <h1>Subscribers</h1>
      <table class="pure-table pure-table-horizontal crud">
        <thead>
          <tr>
            <th>Name</th>
            <th>Email</th>
            <th>
              <form class="pure-form">
                <input
                  v-model="searchQuery"
                  type="search"
                  class="pure-input-rounded"
                  placeholder="Search"
                >
              </form>
            </th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="subscriber in searchResults" :key="subscriber.id">
            <td>{{ subscriber.data().name }}</td>
            <td>{{ subscriber.data().email }}</td>
            <td>
              <button
                @click="removeSubscriberClicked(subscriber)"
                class="pure-button button-xsmall button-error"
              >
                <font-awesome-icon icon="trash-alt"/>
              </button>
            </td>
          </tr>
        </tbody>
      </table>
    </Content>
  </div>
</template>

<script>
import Session from '@/mixins/Session.js'

export default {
  name: 'Subscribers',
  mixins: [Session],
  beforeMount() {
    this.authorize()
  },
  data() {
    return {
      searchQuery: '',
      subscribers: []
    }
  },
  computed: {
    searchResults() {
      if (this.searchQuery === '') {
        return this.subscribers
      } else {
        return this.subscribers.filter(
          subscriber =>
            subscriber
              .data()
              .name.toLowerCase()
              .includes(this.searchQuery.toLowerCase()) ||
            subscriber
              .data()
              .email.toLowerCase()
              .includes(this.searchQuery.toLowerCase())
        )
      }
    }
  },
  methods: {
    getSubscribers() {
      this.$database
        .collection('subscribers')
        .get()
        .then(result => (this.subscribers = result.docs))
    },
    removeSubscriber(subscriber) {
      this.$database
        .collection('subscribers')
        .doc(subscriber.id)
        .delete()
        .then(() => this.getSubscribers())
    },
    removeSubscriberClicked(subscriber) {
      if (confirm(`Remove subscriber ${subscriber.data().email}?`)) {
        this.removeSubscriber(subscriber)
      }
    }
  },
  mounted() {
    this.getSubscribers()
  }
}
</script>
